'use client';

import React, { useEffect } from 'react';
import { motion, AnimatePresence, easeInOut } from 'framer-motion';
import { usePathname } from 'next/navigation';
import { usePreloader } from './PreloaderContext';
import styles from './PagePreloader.module.scss';

const GatherLogo: React.FC<{ showFillAnimation: boolean }> = ({ showFillAnimation }) => {
  // Create the SVG mask data URL with the logo path
  const logoMask = `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1520 84'><path d='M961.434 50.7725C961.434 63.3354 970.872 72.8955 983.435 72.8955C995.997 72.8954 1005.56 63.3354 1005.56 50.7725V1.40918H1016.16V51.0176C1016.16 69.2798 1002.06 83.1611 983.435 83.1611C964.805 83.1611 950.832 69.3105 950.832 51.0176V1.40918H961.434V50.7725ZM42.377 0C61.252 0 76.9402 11.0618 81.5977 26.6582H63.6729C59.3524 19.7945 51.5694 15.4736 42.377 15.4736C27.5772 15.4737 16.4238 26.6581 16.4238 41.5498C16.4239 56.4414 27.6079 67.625 42.377 67.625C53.8981 67.625 63.3361 60.9759 66.2471 51.1094H44.9512V36.5547H83.5898V42.1318C83.5898 65.4193 66.2466 83.0996 42.377 83.0996C18.5074 83.0996 6.36868e-05 65.2049 0 41.5498C0 17.9253 18.1703 2.03992e-05 42.377 0ZM789.75 0C813.589 0 831.79 17.9253 831.79 41.5498C831.79 65.1742 813.742 83.0996 789.75 83.0996C765.758 83.0994 747.741 65.1741 747.741 41.5498C747.741 17.9255 765.911 0.000211624 789.75 0ZM1081 0C1100.55 0 1116.39 12.2258 1120.71 29.4463H1109.4C1105.45 18.0477 1094.39 10.2344 1081 10.2344C1063.29 10.2346 1049.93 23.7473 1049.93 41.5498C1049.93 59.3522 1063.32 72.865 1081 72.8652C1094.39 72.8652 1105.45 65.0518 1109.4 53.6533H1120.71C1116.39 70.8737 1100.58 83.0996 1081 83.0996C1057.13 83.0994 1038.96 65.1741 1038.96 41.5498C1038.96 17.9254 1057.13 0.000198268 1081 0ZM1302.1 0C1325.97 4.62022e-05 1344.14 17.9253 1344.14 41.5498C1344.14 65.1742 1326.1 83.0996 1302.1 83.0996C1278.11 83.0996 1260.06 65.1742 1260.06 41.5498C1260.06 17.9253 1278.23 0 1302.1 0ZM1490.92 0C1505.81 0.000137713 1518.03 9.8971 1518.03 23.042H1507.22C1507.22 15.3513 1500.11 9.52945 1490.67 9.5293C1482.06 9.5293 1474.83 14.4324 1474.83 22.0928C1474.83 40.5997 1519.54 31.2852 1519.54 59.1074C1519.54 73.6619 1506.97 83.0995 1491.25 83.0996C1475.53 83.0996 1462.51 72.6198 1462.51 58.9844L1462.54 59.0156H1473.36C1473.36 67.2886 1481.27 73.5703 1491.41 73.5703C1500.97 73.5702 1508.63 68.2072 1508.63 60.3018C1508.63 41.6724 1463.92 50.2822 1463.92 22.9199C1463.92 8.94746 1476.03 0 1490.92 0ZM182.102 81.751H164.514L158.814 66.1543H124.251L118.674 81.751H101.331L132.278 1.40918H151.246L182.102 81.751ZM252.791 16.5469H230.913V81.751H214.857V16.5469H192.948V1.40918H252.791V16.5469ZM295.505 33.7666H331.142V1.40918H347.197V81.751H331.142V48.9346H295.505V81.751H279.449V1.40918H295.505V33.7666ZM433.82 16.5469H397.021V33.7666H429.96V48.9033H397.021V66.6143H434.402V81.751H380.964V1.40918H433.82V16.5469ZM494.122 1.40918C509.596 1.40918 521.362 12.7162 521.362 27.7305C521.362 39.2516 514.131 48.444 503.56 51.7227L523.691 81.751H503.774L485.39 53.1016H474.45V81.751H458.395V1.40918H494.122ZM702.575 1.40918C716.885 1.40918 727.732 11.8889 727.732 25.8613C727.732 38.4243 718.754 47.9844 706.528 49.6084L730.03 81.751H716.763L693.843 49.8535H678.951V81.751H668.227V1.40918H702.575ZM887.374 1.40918C910.661 1.40933 928.127 18.63 928.127 41.5801C928.127 64.5304 910.661 81.7508 887.374 81.751H856.396V1.40918H887.374ZM1198.23 11.4297H1174.02V81.751H1163.3V11.3984H1139.09V1.40918H1198.23V11.4297ZM1233.53 81.751H1222.8V1.40918H1233.53V81.751ZM1425.99 64.04V1.40918H1436.59V81.751H1425.65L1380.24 19.1201V81.751H1369.52V1.40918H1380.58L1425.99 64.04ZM619.568 1.40918C634.245 1.40925 645.307 12.2262 645.307 26.6582C645.307 41.0902 634.245 51.8144 619.568 51.8145H595.361V81.7207H584.637V1.40918H619.568ZM789.781 10.2344C772.101 10.2344 758.711 23.7472 758.711 41.5498C758.711 59.3524 772.101 72.8652 789.781 72.8652C807.461 72.8652 820.852 59.3523 820.852 41.5498C820.852 23.7472 807.461 10.2345 789.781 10.2344ZM1302.1 10.2344C1284.42 10.2344 1271.03 23.7472 1271.03 41.5498C1271.03 59.3524 1284.42 72.8652 1302.1 72.8652C1319.78 72.8652 1333.17 59.3523 1333.17 41.5498C1333.17 23.7472 1319.78 10.2344 1302.1 10.2344ZM867.089 71.7012H887.221C904.227 71.701 917.126 58.7701 917.126 41.5498C917.126 24.3294 904.196 11.3986 887.221 11.3984H867.089V71.7012ZM129.674 51.3242H153.329L141.563 19.0898L129.674 51.3242ZM595.331 41.7949H619.323C627.811 41.7948 634.337 35.3909 634.337 26.6582C634.337 17.9255 627.811 11.3985 619.323 11.3984H595.331V41.7949ZM678.951 40.5078H702.453C710.604 40.5078 716.763 34.3489 716.763 25.9531C716.763 17.5575 710.604 11.3984 702.453 11.3984H678.951V40.5078ZM474.481 39.1289H493.816C500.098 39.1287 504.878 34.2262 504.878 27.8223C504.878 21.4184 500.098 16.5471 493.816 16.5469H474.481V39.1289Z' fill='white'/></svg>")`;

  return (
    <div 
      style={{
        width: '100%',
        height: '84px',
        position: 'relative',
        WebkitMask: logoMask,
        mask: logoMask,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        overflow: 'hidden'
      }}
    >
      {/* Base gray background */}
      <div 
        style={{
          position: 'absolute',
          inset: '0',
          background: '#2A523E'
        }}
      />
      
      {/* Animated white fill */}
      {showFillAnimation && (
        <motion.div
          style={{
            position: 'absolute',
            inset: '0',
            background: 'white',
            transformOrigin: 'top'
          }}
          initial={{ opacity: 0, scaleY: 0 }}
          animate={{ opacity: 1, scaleY: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.7,
            delay: 0.35,
            ease: easeInOut
          }}
        />
      )}
    </div>
  );
};

const PagePreloader: React.FC = () => {
  const { state, isInitialLoad, showLogo, isLoading, completeLoading } = usePreloader();
  const pathname = usePathname();
  
  // Don't render on admin routes
  const isAdminRoute = pathname.startsWith('/admin') || pathname.startsWith('/login');

  // Effect to automatically complete loading when page content is ready
  useEffect(() => {
    if (isAdminRoute) return;
    if (state === 'covering' && !isLoading && !isInitialLoad) {
      // Add a small delay to ensure the new page has fully rendered
      const timer = setTimeout(() => {
        completeLoading();
      }, 300); // Give the new page time to render
      
      return () => clearTimeout(timer);
    }
  }, [state, isLoading, isInitialLoad, completeLoading, isAdminRoute]);

  if (isAdminRoute) return null;

  // Don't render if hidden
  if (state === 'hidden') return null;

  // Calculate transform based on state
  const getTransform = () => {
    switch (state) {
      case 'covering':
        return 'translateY(0%)'; // Covering the screen
      case 'sliding-up':
        return 'translateY(0%)'; // Slide to cover
      case 'sliding-down':
        return 'translateY(100%)'; // Slide down to reveal
      default:
        return isInitialLoad ? 'translateY(0%)' : 'translateY(100%)';
    }
  };

  // Calculate duration based on state
  const getDuration = () => {
    switch (state) {
      case 'sliding-up':
        return 0.6;
      case 'sliding-down':
        return 0.7; // Slightly faster for smoother feel
      default:
        return 0;
    }
  };

  // Calculate easing based on state
  const getEasing = () => {
    switch (state) {
      case 'sliding-up':
        return [0.22, 1, 0.36, 1] as const; // Current smooth ease
      case 'sliding-down':
        return [0.25, 0.46, 0.45, 0.94] as const; // Silky smooth ease-out
      default:
        return [0.22, 1, 0.36, 1] as const;
    }
  };

  return (
    <>
      {/* Fixed logo in center of viewport with fade animations */}
      <AnimatePresence>
        {showLogo && (
          <motion.div
            className={styles.preloader__logo}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ 
              duration: 0.5,
              ease: easeInOut
            }}
          >
            <GatherLogo showFillAnimation={showLogo} />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Sliding container that masks the logo */}
      <motion.div
        className={styles.preloader}
        initial={{ 
          transform: isInitialLoad ? 'translateY(0%)' : 'translateY(100%)'
        }}
        animate={{ 
          transform: getTransform()
        }}
        transition={{ 
          duration: getDuration(),
          ease: getEasing()
        }}
      />
    </>
  );
};

export default PagePreloader;
